import { useMutation } from '@tanstack/react-query';

import { coreActionsAxiosClient } from '@/lib';
import { withLogger } from '@/utils';

import { meetingMutation } from '../data/mutation-keys';

type Param = {
  id: string;
};

type Return = {
  message: string;
};

export type MeetingTemplateDelete = {
  param: Param;
  return: Return;
};

const mutateMeetingTemplateDelete = withLogger(
  async (param: Param): Promise<Return> => {
    const data: Return = await coreActionsAxiosClient.delete(
      `/template/destroy/${param.id}`,
    );
    return data;
  },
);

export const useMutateMeetingTemplateDelete = () => {
  const mutation = useMutation({
    mutationKey: meetingMutation.delete,
    mutationFn: mutateMeetingTemplateDelete,
  });
  return mutation;
};
